import { BathroomExperience, BathroomExperiences } from "@inter-ikea-range/bathroom-experience";

import type { EnvironmentSettings, Experience } from "@inter-ikea-space-platform/experience";

// room experience
export const bathroomExperience = (settings: EnvironmentSettings) => {
  const { proxyUrl } = settings;

  const baseUrl = `${proxyUrl}/addon-app/range/v1.0`;
  return {
    ...BathroomExperience(settings),
    id: "bathroom-experience",
    endpoints: {
      productMenuConfigUrl: `${baseUrl}/bathroom-experience/menu/latest/`,
    },
  };
};

// range packages
export const bathroomPackages = (settings: EnvironmentSettings): Experience[] => {
  const allBathroomPackages = BathroomExperiences.map((experience) => experience(settings));

  // should only load when opening old designs before bathroom was split up into smaller packages
  const deprecatedBathroomExperience: Experience = {
    id: "bathroom",
    consumes: [...allBathroomPackages.map(({ id }) => id)],
    roomTypes: undefined, // should not be linked to any room type
    onReady: () => {},
  };

  const bathroomExperiences = [deprecatedBathroomExperience, ...allBathroomPackages];

  return bathroomExperiences;
};
